import { RootState } from "@store/rootReducer";

export const selectTokenId = (s: RootState) => s.auth.tokenId;
export const selectUserId = (s: RootState) => s.auth.userId;